import { render, staticRenderFns } from "./addExam.vue?vue&type=template&id=00c4cf79&scoped=true"
import script from "./addExam.vue?vue&type=script&lang=js"
export * from "./addExam.vue?vue&type=script&lang=js"
import style0 from "./addExam.vue?vue&type=style&index=0&id=00c4cf79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c4cf79",
  null
  
)

export default component.exports